const fantom = require("./fantom");

const { BigNumber } = require("ethers");
const MAX_AMOUNT = BigNumber.from(2).pow(256).sub(1);

const CONTRACT_NAME = "BeefyStrategy";

const CHAINID_TO_NETWORK_NAME = {
  250: "fantom",
  56: "bsc",
};

const MAP_NETWORK_TO_RPC = {
  fantom: process.env.REACT_APP_POLYGON_RPC_URL || "https://rpc.ftm.tools/",
  bsc: process.env.BSC_RPC_URL || "https://bsc-dataseed.binance.org",
};

module.exports = {
  fantom,
  MAX_AMOUNT,
  CONTRACT_NAME,
  CHAINID_TO_NETWORK_NAME,
  MAP_NETWORK_TO_RPC,
};
